// Paltform API user
export const user = 'client';
export const password = 'client';

// API base url
export const baseURL = 'http://localhost/projekte/epu/web';

// API Endpoints
export const loginURL = baseURL + '/user/login?_format=json';
export const logoutURL = baseURL + '/user/logout?_format=json';
export const getInitStoriesURL = baseURL + '/match/get_stories/?_format=json';
export const selectStoriesURL = baseURL + '/match/select_stories/?_format=json';
export const getStorylineURL = baseURL + '/match/storyline/{type}/{id}/?_format=json';
export const saveStorylineURL = baseURL + '/match/save_storyline/?_format=json';
export const getMatchingURL = baseURL + '/match/get_matching/?_format=json';
export const getHostURL = baseURL + '/match/storylinehost/{type}/{id}?_format=json';
export const createHostURL = baseURL + '/match/storylinehost?_format=json';
export const deleteHostURL = baseURL + '/match/storylinehost/{type}/{id}/?_format=json';
export const syncHostURL = baseURL + '/match/sync_hosts?_format=json';
export const getAllHostsURL = baseURL + '/match/get_all_hosts?_format=json';
